import { Grid } from '@mui/material';
import React from 'react'
import TermsAndConditions from './TermsAndCondition';

function TermsAndConditionAllPages() {
  return (
    <Grid>
        <TermsAndConditions/>
    </Grid>
  )
}
export default TermsAndConditionAllPages;